import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
window.AOS = AOS;

